export const projectDescription = [
    {
        "id":1,
        "name":"DonationHub",
        "description":["Developed a website to accept donations online to aid individuals in need. Our platform aims to close the gap that exists between Donators and Donatees.Designed several front-end elements, like Authentication and CRUD operations for postings, that interact with the back-end."],
        "tech_stack":"JavaScript, React Js, CSS, Node Js, MongoDB, JWT, Netlify, and Heroku",
        "image_link":"./img/Donation.png",
        "project_link":"https://donationhub.netlify.app/",
        "github_link":""
    },
    {
        "id":2,
        "name":"Music Player",
        "description":["It have features which a music player should have.","But it have some new features like Random Gif Generator and Single Repeat Mode which are not in the original version.",
                "Random Gif Generator : It will generate a random gif image from Tenor API which is according to song which is playing.",
                "Single Repeat Mode : It will play a song only two time and move to another song without stucking in a infinite loop."],
        "tech_stack":"HTML, CSS, JavaScript, Firebase FireStore, Firebase Storage",
        "image_link":"./img/Front.png",
        "project_link":"https://streammusic.netlify.app/",
        "github_link":"https://github.com/Aman12305/spotify-clone"
    },
    {
        "id":3,
        "name":"StreamTrend",
        "description":["Created a platform that allows users to see popular TV series and movie trailers from many OTT services in one location.The TMDB API and the Youtube API are used to retrieve and show data and videos, respectively, on websites."],
        "tech_stack":"React Js, TMDB API, Youtube API ,CSS",
        "image_link":"./img/ott.png",
        "project_link":"https://streamtrend.netlify.app/",
        "github_link":"https://github.com/Aman12305/OTT-platform"
    },
    {
        "id":4,
        "name":"Learnify",
        "description":["Created a platform that uses Augmented Reality to let students see their 3D models on camera-enabled devices while learning about body parts, geometric forms, and the alphabet. In order to find some markers specific to certain 3D models, it makes use of image processing libraries."],
        "tech_stack":"A-Frame, HTML, CSS, Netlify-Deployment, Augmented-Reality",
        "image_link":"./img/learnify.png",
        "project_link":"https://learnifyar.netlify.app/",
        "github_link":"https://github.com/Aman12305/Learnify_AR_Project"
    }
]


var data = [
    {
        name: "Home",
        start: "<Home>",
        end: "</Home>"
    },
    {
        name: "About",
        start: "<About>",
        end: "</About>"
    },
    {
        name: "Skills",
        start: "<Skills>",
        end: "</Skills>"
    },
    {
        name: "Allproject",
        start: "<Projects>",
        end: "</Projects>"
    },
    {
        name: "Contact",
        start: "<Contact>",
        end: "</Contact>"
    }

];

var divname = {
    start:"<div>",
    end:"</div>"
}


var skillDescription = [
    "I am proficient in C++ and C programming. Data Structures, Algorithms, DBMS, and OOP concepts are subject areas in which I excel. I am capable in configuring and managing a Windows OS.",
    "I am also familiar with MySQL, MongoDB, FireBase, HTML, CSS, JavaScript, React, and Node.js. Additionally, I've worked with Git and Github before. In my spare time, I've created a few apps that use the entire tech stack that was previously described."
];

var aboutDescription = [
    "I study electrical engineering with a minor in computer science at Delhi Technological University, which is in Delhi, India.",
    "Basically Computer science is my main area of interest, thus I choose to pursue a career in this field. I'm very motivated by myself and am always looking for fresh opportunities and difficulties. I'm a cooperative person who's always looking to increase my skill set and information base."
];


const skillIcon = [
    {
        id:1,
        name:"c",
        img:"./img/c.png",
        alt:"c",
        ty0:"0px",
        ty50_1:"50%",
        ty50_2:"75%",
        ty50_3:"50%",
        ty100:"0px",
        tx0:"0px",
        tx50_1:"50%",
        tx50_2:"75%",
        tx50_3:"50%",
        tx100:"0px",
        scale0:"1",
        scale50_1:"0.8",
        scale50_2:"0.5",
        scale50_3:"0.8",
        scale100:"1",
    },
    {
        id:2,
        name:"c++",
        img:"./img/c++.png",
        alt:"c++",
        ty0:"0px",
        ty50_1:"50%",
        ty50_2:"80%",
        ty50_3:"50%",
        ty100:"0px",
        tx0:"0px",
        tx50_1:"0px",
        tx50_2:"0px",
        tx50_3:"0px",
        tx100:"0px",
        scale0:"1",
        scale50_1:"0.8",
        scale50_2:"0.5",
        scale50_3:"0.8",
        scale100:"1",
    },
    {
        id:3,
        name:"firbase",
        img:"./img/firebase.png",
        alt:"firebase",
        ty0:"0px",
        ty50_1:"50%",
        ty50_2:"80%",
        ty50_3:"50%",
        ty100:"0px",
        tx0:"0px",
        tx50_1:"-50%",
        tx50_2:"-80%",
        tx50_3:"-50%",
        tx100:"0px",
        scale0:"1",
        scale50_1:"0.8",
        scale50_2:"0.5",
        scale50_3:"0.8",
        scale100:"1",
    },
    {
        id:4,
        name:"html",
        img:"./img/html.png",
        alt:"html",
        ty0:"0px",
        ty50_1:"0px",
        ty50_2:"0px",
        ty50_3:"0px",
        ty100:"0px",
        tx0:"0px",
        tx50_1:"50%",
        tx50_2:"80%",
        tx50_3:"50%",
        tx100:"0px",
        scale0:"1",
        scale50_1:"0.8",
        scale50_2:"0.5",
        scale50_3:"0.8",
        scale100:"1",
    },
    {
        id:5,
        name:"github",
        img:"./img/github.png",
        alt:"github",
        ty0:"0px",
        ty50_1:"0px",
        ty50_2:"0px",
        ty50_3:"0px",
        ty100:"0px",
        tx0:"0px",
        tx50_1:"0px",
        tx50_2:"0px",
        tx50_3:"0px",
        tx100:"0px",
        scale0:"0.8",
        scale50_1:"1",
        scale50_2:"1.4",
        scale50_3:"1",
        scale100:"0.8",
    },
    {
        id:6,
        name:"react",
        img:"./img/react.png",
        alt:"react",
        ty0:"0px",
        ty50_1:"0%",
        ty50_2:"0%",
        ty50_3:"0%",
        ty100:"0px",
        tx0:"0px",
        tx50_1:"-50%",
        tx50_2:"-80%",
        tx50_3:"-50%",
        tx100:"0px",
        scale0:"1",
        scale50_1:"0.8",
        scale50_2:"0.5",
        scale50_3:"0.8",
        scale100:"1",
    },
    {
        id:7,
        name:"css",
        img:"./img/css.png",
        alt:"css",
        ty0:"0px",
        ty50_1:"-50%",
        ty50_2:"-80%",
        ty50_3:"-50%",
        ty100:"0px",
        tx0:"0px",
        tx50_1:"50%",
        tx50_2:"80%",
        tx50_3:"50%",
        tx100:"0px",
        scale0:"1",
        scale50_1:"0.8",
        scale50_2:"0.5",
        scale50_3:"0.8",
        scale100:"1",
    },
    {
        id:8,
        name:"js",
        img:"./img/js.png",
        alt:"js",
        ty0:"0px",
        ty50_1:"-50%",
        ty50_2:"-80%",
        ty50_3:"-50%",
        ty100:"0px",
        tx0:"0px",
        tx50_1:"0px",
        tx50_2:"0px",
        tx50_3:"0px",
        tx100:"0px",
        scale0:"1",
        scale50_1:"0.8",
        scale50_2:"0.5",
        scale50_3:"0.8",
        scale100:"1",
    },
    {
        id:9,
        name:"node",
        img:"./img/node.png",
        alt:"node",
        ty0:"0px",
        ty50_1:"-50%",
        ty50_2:"-80%",
        ty50_3:"-50%",
        ty100:"0px",
        tx0:"0px",
        tx50_1:"-50%",
        tx50_2:"-80%",
        tx50_3:"-50%",
        tx100:"0px",
        scale0:"1",
        scale50_1:"0.8",
        scale50_2:"0.5",
        scale50_3:"0.8",
        scale100:"1",
    }
]

export {data,divname,skillDescription,aboutDescription,skillIcon};
